import { render, staticRenderFns } from "./afterSalesList.vue?vue&type=template&id=618227b8&scoped=true"
import script from "./afterSalesList.vue?vue&type=script&lang=js"
export * from "./afterSalesList.vue?vue&type=script&lang=js"
import style0 from "./afterSalesList.vue?vue&type=style&index=0&id=618227b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618227b8",
  null
  
)

export default component.exports